export default "__VITE_ASSET__DYS7mAYB__"